import * as React from "react";

export const Emoji = () => (
    <>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.00002 3.46401C5.01769 3.46401 2.60002 5.88167 2.60002 8.86401C2.60002 11.8463 5.01769 14.264 8.00002 14.264C10.9824 14.264 13.4 11.8463 13.4 8.86401C13.4 8.53264 13.6687 8.26401 14 8.26401C14.3314 8.26401 14.6 8.53264 14.6 8.86401C14.6 12.5091 11.6451 15.464 8.00002 15.464C4.35494 15.464 1.40002 12.5091 1.40002 8.86401C1.40002 5.21893 4.35494 2.26401 8.00002 2.26401C8.3314 2.26401 8.60002 2.53264 8.60002 2.86401C8.60002 3.19538 8.3314 3.46401 8.00002 3.46401Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 1.26401C12.3314 1.26401 12.6 1.53264 12.6 1.86401V6.86401C12.6 7.19538 12.3314 7.46401 12 7.46401C11.6687 7.46401 11.4 7.19538 11.4 6.86401V1.86401C11.4 1.53264 11.6687 1.26401 12 1.26401Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.90002 4.36401C8.90002 4.03264 9.16865 3.76401 9.50002 3.76401H14.5C14.8314 3.76401 15.1 4.03264 15.1 4.36401C15.1 4.69538 14.8314 4.96401 14.5 4.96401H9.50002C9.16865 4.96401 8.90002 4.69538 8.90002 4.36401Z"
        />
        <path d="M7 8.1629C7 8.71519 6.55228 9.1629 6 9.1629C5.44772 9.1629 5 8.71519 5 8.1629C5 7.61062 5.44772 7.1629 6 7.1629C6.55228 7.1629 7 7.61062 7 8.1629Z" />
        <path d="M11 8.1629C11 8.71519 10.5523 9.1629 10 9.1629C9.44772 9.1629 9 8.71519 9 8.1629C9 7.61062 9.44772 7.1629 10 7.1629C10.5523 7.1629 11 7.61062 11 8.1629Z" />
        <path d="M9.90992 11.3518C10.2283 10.9005 9.76774 10.4162 9.21545 10.4162H6.78455C6.23226 10.4162 5.77175 10.9005 6.09008 11.3518C6.18446 11.4856 6.29949 11.61 6.43344 11.7217C6.84892 12.0679 7.41243 12.2624 8 12.2624C8.58758 12.2624 9.15108 12.0679 9.56656 11.7217C9.70051 11.61 9.81554 11.4856 9.90992 11.3518Z" />
    </>
);
